// extracted by mini-css-extract-plugin
module.exports = {"selectWrapper":"nativeSelect_selectWrapper__KUTtb","select":"nativeSelect_select__M24bi","arrow":"nativeSelect_arrow__dEZEt","arrow__rotate":"nativeSelect_arrow__rotate__7Xxvt"};